import React from "react";
import { Typography, Box, Tooltip } from "@material-ui/core";
import dayjs from "dayjs";
import {
  BAR_CHART_HEIGHT,
  formatDollars,
  getForecastCategoryCents,
  stripCategoryPrefix,
} from "./utils";

function VerticalBar({ item, maxCents, categories, colorMap, classes, selected, onSelect }) {
  const totalCents = parseFloat(item.totalCents) || 0;
  const forecastCents = parseFloat(item.forecast?.unbilledTotalCents) || 0;
  const maxBarHeight = BAR_CHART_HEIGHT - 80;

  const billedHeight = maxCents > 0 ? (totalCents / maxCents) * maxBarHeight : 0;
  const forecastHeight = maxCents > 0 ? (forecastCents / maxCents) * maxBarHeight : 0;

  return (
    <Box
      className={`${classes.barColumn} ${selected ? classes.barColumnSelected : ""}`}
      onClick={() => onSelect(item.month)}
    >
      {forecastCents > 0 && (
        <Typography variant="caption" className={classes.forecastAmount}>
          +${formatDollars(forecastCents)} est.
        </Typography>
      )}
      <Typography variant="caption" className={classes.barAmount}>
        ${item.totalDollars || formatDollars(totalCents)}
      </Typography>
      {forecastCents > 0 && (
        <Box
          className={classes.forecastStack}
          style={{ height: forecastHeight, borderRadius: totalCents > 0 ? 0 : "4px 4px 0 0" }}
        >
          {categories.map((cat) => {
            const catCents = getForecastCategoryCents(item, cat);
            if (catCents === 0 || forecastCents === 0) return null;
            const segPct = (catCents / forecastCents) * 100;
            return (
              <Tooltip
                key={cat}
                title={`${stripCategoryPrefix(cat)} (forecast): ${item.forecast.byCategory[cat].chargeCount} charges - $${formatDollars(catCents)}`}
              >
                <Box
                  className={classes.barSegment}
                  style={{
                    height: `${segPct}%`,
                    backgroundColor: colorMap[cat],
                    opacity: 0.4,
                    backgroundImage: `repeating-linear-gradient(45deg, transparent, transparent 3px, rgba(255,255,255,0.4) 3px, rgba(255,255,255,0.4) 6px)`,
                  }}
                />
              </Tooltip>
            );
          })}
        </Box>
      )}
      <Box
        className={classes.barStack}
        style={{ height: billedHeight, borderRadius: forecastCents > 0 ? 0 : "4px 4px 0 0" }}
      >
        {item.byCategory &&
          categories.map((cat) => {
            const catData = item.byCategory[cat];
            if (!catData || totalCents === 0) return null;
            const segPct = (parseFloat(catData.totalCents) / totalCents) * 100;
            return (
              <Tooltip
                key={cat}
                title={`${stripCategoryPrefix(cat)}: ${catData.chargeCount} charges - $${formatDollars(catData.totalCents)}`}
              >
                <Box
                  className={classes.barSegment}
                  style={{ height: `${segPct}%`, backgroundColor: colorMap[cat] }}
                />
              </Tooltip>
            );
          })}
      </Box>
      <Typography
        variant="caption"
        className={`${classes.barLabel} ${selected ? classes.barLabelSelected : ""}`}
      >
        {dayjs(item.month).format("MMM YYYY")}
      </Typography>
    </Box>
  );
}

export default function BarChartView({ data, maxCents, categories, colorMap, classes, selectedMonth, onSelect }) {
  return (
    <Box className={classes.chartArea}>
      {[...data].reverse().map((item) => (
        <VerticalBar
          key={item.month}
          item={item}
          maxCents={maxCents}
          categories={categories}
          colorMap={colorMap}
          classes={classes}
          selected={item.month === selectedMonth}
          onSelect={onSelect}
        />
      ))}
    </Box>
  );
}
